import React from 'react';
import AInput from '../../../../common/formFeilds/customInput/AInput';
import { Col, Row } from 'reactstrap';
import { inputStyles, labelStyles } from '../utils';
import AButton from '../../../../common/form-fields-mui/AButton';
import { useParams } from "react-router";

const fields = [
    { label: 'Student Name', value: 'name' },
    { label: 'DOB', value: 'dateOfBirth' },
    { label: "Father's name", value: 'studentFatherName' },
]


const StudentDetails = ({
    psid,
    setPsid,
    resultInfo
}) => {

    const { psid: currentPsid } = useParams();

    return (
        <>
            <h3 className='mt-1 mb-0'>Student Details</h3>
            <Row>
                <Col md="4">
                    <AInput
                        label="Roll no" 
                        disabled
                        labelStyle={labelStyles}
                        style={inputStyles}
                        value={resultInfo?.rollNo}
                    />
                </Col>
                <Col md="4">
                    <AInput
                        label="PSID"
                        labelStyle={labelStyles}
                        style={inputStyles}
                        className="student-details-psid"
                        value={psid}
                        disabled
                        handler={val => setPsid(val)}
                    />
                </Col>
                <Col md="4">
                    {/* {resultInfo?.psid !== currentPsid &&  */}
                    <AButton
                        variant='link'
                        className='mt-4'
                        onClick={() => setPsid(currentPsid)

                        }
                    >
                        Map current psid
                    </AButton>
                    {/* } */}
                </Col>
            </Row>
            <Row>
                {fields?.map((field, idx) =>
                    <Col md="4" key={idx}>
                        <AInput
                            labelStyle={labelStyles}
                            style={inputStyles}
                            label={field?.label}
                            value={resultInfo?.[field?.value]}
                            disabled
                        />
                    </Col>
                )}
            </Row>
        </>

    );
}

export default StudentDetails;